// This file is AUTOGENERATED, do not edit it manually!!!

export const users = {
    securitylog_msg_LoginChanged: 'Giriş Kullanıcı {0} ile değiştirildi .',
    securitylog_msg_LoginChangedBySelf: 'Giriş değiştirildi .',
    securitylog_msg_PasswordChanged: 'Şifre kullanıcı kullanıcı tarafından değiştirildi {0}.',
    securitylog_msg_PasswordChangedBySelf: 'Şifre değiştirildi .',
    securitylog_msg_PasswordIncorrect: 'Yanlış şifre .',
    securitylog_msg_RecoveryRequest: 'Kurtarma isteği .',
    securitylog_msg_UserLockout: 'Kullanıcı geçersiz şifre denemelerinden sonra kilitlendi.',
};
